export enum AIPromptsToGenerate{
    None = 0,
    PropertyDescription = 1,
    PropertyRoomDescription = 2,
    PropertyRoomTemplateDescription = 3
}